import dayjs from 'dayjs';
import { Duration } from 'dayjs/plugin/duration.js';
import { kHoursPerDay, kMinutesPerHour } from '../../utility/constants.js';
import { MapUtils } from '../../utility/map-utils.js';
import { DataModel, DataModelBuilder, SerializationContext, SerializedData } from '../dto/dto.js';

export class TimeOfDay extends DataModel {
  static readonly TYPE_ID: string = '342a0c2d03c648f389a448d062838e92';

  constructor(
    public readonly hour: number,
    public readonly minute: number,
  ) {
    super();
  }

  get inMinutes() {
    return this.hour * kMinutesPerHour + this.minute;
  }

  get asFormattedString(): string {
    return `${(this.hour % kHoursPerDay).toString().padStart(2, '0')}:${this.minute.toString().padStart(2, '0')}`;
  }

  get $typeId() {
    return TimeOfDay.TYPE_ID;
  }

  static midnight() {
    return new TimeOfDay(0, 0);
  }

  static fromDate(date: dayjs.Dayjs): TimeOfDay {
    return new TimeOfDay(date.hour(), date.minute());
  }

  static fromMinutes(minutes: number): TimeOfDay {
    // minutes = minutes % kMinutesPerDay;
    return new TimeOfDay(Math.floor(minutes / kMinutesPerHour), minutes % kMinutesPerHour);
  }

  static fromMap(context: SerializationContext, map: SerializedData): TimeOfDay {
    return new TimeOfDay(
        MapUtils.get<number>(map, 'hour'),
        MapUtils.get<number>(map, 'minute'),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'hour': this.hour,
      'minute': this.minute,
    };
  }

  clone(): this {
    return new TimeOfDay(
        this.hour,
        this.minute,
    ) as this;
  }

  isSame(other: TimeOfDay): boolean {
    if(other === this) {
      return true;
    }

    return other.hour === this.hour &&
        other.minute === this.minute;
  }

  add(duration: Duration): TimeOfDay {
    return TimeOfDay.fromMinutes(this.inMinutes + duration.asMinutes());
  }

  toString(): string {
    return this.asFormattedString;
  }
}

export class TimeOfDayBuilder extends DataModelBuilder<TimeOfDay> {
  build(context: SerializationContext, map: SerializedData): TimeOfDay {
    return TimeOfDay.fromMap(context, map);
  }
}
